
import Vue from "vue";

export default Vue.extend({
  name: "Error",
  props: {
    id: { type: String, default: "outreach" },
  },
});
